import { z } from 'zod';

import { getIconColorByContentType } from '@/entities/Document';
import { availabilityReasonFromDsbStatus, contentAvailableFromApiFields } from '@/entities/Tree';

const hashQuote = (quote: string): string => {
  let hash = 0;

  for (let i = 0; i < quote.length; i += 1) {
    hash = (hash * 31 + quote.charCodeAt(i)) >>> 0;
  }

  return hash.toString(36);
};

export const documentPathItemSchema = z
  .object({
    id: z.string(),
    name: z.string(),
  })
  .transform((raw) => ({
    id: raw.id,
    name: raw.name,
  }));

export const documentSearchItemSchema = z
  .object({
    id: z.string(),
    file_name: z.string(),
    name: z.string().nullable().optional(),
    content_type: z.string(),
    path: z.array(documentPathItemSchema),
    page_number: z.number(),
    quote: z.string(),
    combined_score: z.number().optional(),
    created_at: z.string().optional(),
    content_available: z.boolean().optional(),
    dsb_status: z.string().nullable().optional(),
  })
  .transform((raw) => {
    return {
      id: raw.id,
      name: raw.file_name ?? raw.name,
      contentType: raw.content_type,
      path: raw.path,
      pathString: raw.path.map((item) => item.name).join(' / '),
      pageNumber: raw.page_number,
      quote: raw.quote,
      iconColor: getIconColorByContentType(raw.content_type),
      searchResultId: `${raw.id}-${raw.page_number}-${hashQuote(raw.quote)}`,
      combinedScore: raw.combined_score ?? null,
      createdAt: raw.created_at ?? null,
      contentAvailable: contentAvailableFromApiFields(raw),
      availabilityIconReason: availabilityReasonFromDsbStatus(raw.dsb_status ?? null),
    };
  });

export type DocumentPathItem = z.infer<typeof documentPathItemSchema>;
export type DocumentSearchItemApi = z.input<typeof documentSearchItemSchema>;
export type DocumentSearchItem = z.infer<typeof documentSearchItemSchema>;

export const documentsSearchResponseSchema = z.object({
  items: z.array(documentSearchItemSchema),
  total: z.number(),
});

export type DocumentsSearchResponseApi = z.input<typeof documentsSearchResponseSchema>;
export type DocumentsSearchResponse = z.infer<typeof documentsSearchResponseSchema>;
